import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import GlobalTooltip from 'components/GlobalTooltip';

/**
 * Bulk actions header shown when rows are selected: Delete, Move, Copy, Share, Download, Mark as Read.
 */
const ListViewBulkActionsHeader = React.memo(function ListViewBulkActionsHeader({
  isClientFileManager,
  isGlobalFileManager,
  selectedRows,
  containsFolders,
  setShowBulkDeleteModal,
  setShowBulkMoveModal,
  setShowShareFileModal,
  setIsCopy,
  onDownload,
  onMarkAsRead,
}) {
  const isVirtualFile = useMemo(() => selectedRows.some((row) => row?.is_virtual), [selectedRows]);

  return (
    <div className="flex flex-wrap align-items-end justify-content-end gap-2 d-flex files-buttons">
      {!isClientFileManager && (
        <>
          {!isVirtualFile && (
            <Button className="p-button p-button-primary ms-2" onClick={() => setShowBulkDeleteModal(true)}>
              <i className="icon-delete text-white me-2 pointer" aria-hidden="true" title="delete" />
              Delete
            </Button>
          )}
        </>
      )}

      {!isGlobalFileManager && !isClientFileManager && (
        <>
          {!isVirtualFile && (
            <Button
              className="p-button p-button-primary ms-2"
              onClick={() => {
                setShowBulkMoveModal(true);
                setIsCopy(false);
              }}
            >
              <i className="icon-move text-white me-2 pointer" aria-hidden="true" title="Move" /> Move
            </Button>
          )}

          <Button
            className="p-button p-button-primary ms-2"
            onClick={() => {
              setShowBulkMoveModal(true);
              setIsCopy(true);
            }}
          >
            <i className="icon-copy text-white me-2 pointer" aria-hidden="true" title="Copy" /> Copy
          </Button>

          <Button className="p-button p-button-primary outline ms-2" onClick={() => setShowShareFileModal(true)}>
            Share
          </Button>
        </>
      )}

      <Button className="p-button p-button-primary ms-2" onClick={onDownload}>
        <i className="icon-save text-white me-2 pointer" aria-hidden="true" title="Download" /> Download
      </Button>

      {!containsFolders && (
        <Button className="p-button p-button-primary ms-2" onClick={onMarkAsRead}>
          <i className="icon-check text-white me-2 pointer" aria-hidden="true" title="Mark as Read" /> Mark as Read
        </Button>
      )}
    </div>
  );
});

export default ListViewBulkActionsHeader;
